export default __webpack_public_path__ + "static/media/hand-terry@3x.7c20778e.png";